<template>
    <div class="nybj1">
        <div class="nybj2">
            <div class="nybox" style="border:1px solid #03A643;">

                <div class="ny_left" style="height:100%">
                    <div class="left_dh">
                        <div class="ldh_title">
                            <h2>
                                门诊<span></span></h2>
                        </div>
                        <div class="ldh_nr">
                            <ul>
                                <li class="hover_b"><a href="#" title="门诊时间">门诊时间</a></li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div class="ny_right">
                    <div class="dqwz">
                        <p>当前位置：<a href="index.aspx">首页</a>&nbsp;&gt;&nbsp;门诊时间
                        </p>
                    </div>
                    <div class="ks_nr ks_nr_order">

                        <div v-for="(item,i) in department_list" :key="i">
                            <h4 onclick="">
                                <em></em>
                                {{item.title}}&nbsp;&nbsp;<span id="rptPlist_lbSj_0"></span>
                            </h4>
                            <ul class="border-bottom">

                                <li v-for="(item2,i2) in item.child" :key="i2">
                                    <router-link :to="'/department-detail/'+item2.id" style="text-align:center">
                                        {{item2.title}}<br>{{item2.item2}}
                                    </router-link>
                                </li>

                            </ul>

                            <div class="clearFloat"></div>
                        </div>


                    </div>
                </div>
                <div class="dbgd">
                    <img src="../../assets/images/c_04.png" />
                </div>
                <div class="clearFloat" style="height:70px"></div>


            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'OutDepartmentInfo',
        data(){
            return{
                department_list:[]
            }
        },
        methods:{
            getList:function(){
                let that = this;
                that.$http.get(this.$api.getOutDepartment.url,{}).then(result => {
                    console.log(result);
                    that.department_list = result.data;
                });

            }
        },
        mounted(){
            this.getList();
        }
    }
</script>